import React from "react";
import "./index.css";
import "./App.css";
import Router from "./router/Router.jsx";
import { BrowserRouter } from "react-router-dom";

const getBasename = () => {
  const { pathname } = window.location;
  if (pathname === "/fa" || pathname.startsWith("/fa/")) {
    return "/fa";
  }
  return "";
};

function App() {
  return (
    <BrowserRouter basename={getBasename()}>
      <Router />
    </BrowserRouter>
  );
}

export default App;
